import { useFormContext, useWatch } from 'react-hook-form';
import { QuoteDepositType } from '@trnsact/trnsact-shared-types';
import { DealBuilderFormValues, DealBuilderSummary } from '../types';
import { useDealBuilderContext } from '../context/DealBuilderContext';
import { calculateNetTrade, roundToCents } from '../lib';

export const useDealBuilderSummary = (): DealBuilderSummary => {
  const { control } = useFormContext<DealBuilderFormValues>();
  const {
    pricing: { calculatedTotals },
  } = useDealBuilderContext();

  const depositValue = useWatch({ control, name: 'pricing.customerDeposit.value' });
  const depositType = useWatch({ control, name: 'pricing.customerDeposit.type' });
  const tradeInRows = useWatch({ control, name: 'pricing.tradeIn' });

  const hardCost = calculatedTotals.equipments.price + calculatedTotals.attachments.price;
  const feesAndTaxes =
    calculatedTotals.invoice.fees +
    calculatedTotals.invoice.taxes +
    calculatedTotals.equipments.fees +
    calculatedTotals.equipments.taxes +
    calculatedTotals.attachments.fees +
    calculatedTotals.attachments.taxes;

  const customerDeposit =
    depositType === QuoteDepositType.Percentage
      ? ((depositValue ?? 0) / 100) * (hardCost + feesAndTaxes)
      : (depositValue ?? 0);

  const tradeIn = roundToCents((tradeInRows ?? []).reduce((sum, row) => sum + calculateNetTrade(row), 0));

  const balanceDue = hardCost + feesAndTaxes - customerDeposit - tradeIn;

  return { hardCost, feesAndTaxes, customerDeposit, tradeIn, balanceDue };
};
